import { Space } from 'antd';
import { FC, ReactNode } from 'react';
import styles from './index.module.scss';
import { Wrapper } from '@maxtropy/components';

export interface ExpectPageProps {
  imgUrl: string;
  title?: ReactNode;
}

const ExpectPage: FC<ExpectPageProps> = ({ imgUrl, title }) => {
  return (
    <Wrapper>
      <div className={styles.content}>
        <Space size={24} align="center" direction="vertical">
          <img className={styles.img} src={imgUrl} alt="" />
          <span className={styles.text}>{title}</span>
        </Space>
      </div>
    </Wrapper>
  );
};

export default ExpectPage;
